<template>
  <textarea
    v-bind="$attrs"
    :value="value"
    @input="updateValue"
  />
</template>
<script>
import _debounce from 'lodash/debounce'
import { mapState } from 'vuex'
import * as localStorageExpiry from '@/utils/local.storage.expiry'

const oneDay = 24 * 60 * 60 * 1000

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    uniqueId: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentationId: (state) => state.presentation.id,
      slideId: (_, getters) => getters.activeActivity.id,
    }),
    storageKey() {
      // uniqueId is used for the case of a textarea that is not tied to a slide (e.g. a feedback textarea)
      if (this.uniqueId) return `${this.audienceId}-${this.presentationId}-${this.uniqueId}`
      return `${this.audienceId}-${this.presentationId}-${this.slideId}`
    },
  },
  watch: {
    value(value) {
      if (value) return
      localStorage.removeItem(this.storageKey)
    },
    audienceId() {
      // For every component outside presentation, the audienceId takes a while to load
      // Update it to avoid blank value due to undiefined audienceId
      this.updateWithValueFromStore()
    },
    presentationId() {
      // For every component outside presentation, the presentationId takes a while to load
      // Update it to avoid blank value due to undiefined presentationId
      this.updateWithValueFromStore()
    },
  },
  mounted() {
    this.updateWithValueFromStore()
  },
  methods: {
    updateWithValueFromStore() {
      const storedVal = localStorageExpiry.getWithExpiry(this.storageKey)
      if (!storedVal) return
      this.$emit('input', storedVal)
    },
    updateValue: _debounce(function updateValue(event) {
      localStorageExpiry.setWithExpiry(this.storageKey, event.target.value, oneDay)
      this.$emit('input', event.target.value) // Emit input event to update parent's data property
    }, 100),
  },

}
</script>
